import { render, staticRenderFns } from "./WorkFileAddressAndContact.vue?vue&type=template&id=426560b5"
import script from "./WorkFileAddressAndContact.vue?vue&type=script&lang=ts"
export * from "./WorkFileAddressAndContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports